import type {DataRouterDeletePagePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewTreeDeleteRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewTreeDeleteRoute', {
  path: '/:owner/:repo/tree/delete/:branch/*',
  queries: [mainQuery<DataRouterDeletePagePayload>({encodeFetchPath: true})],
})
